import { Outlet } from 'react-router-dom';
import AuthGuard from '@/components/feature/AuthGuard';

export default function AuthGuardLayout() {
  return (
    <AuthGuard allowedRoles={['super_admin', 'admin', 'manager', 'agent']} redirectTo="/admin">
      <Outlet />
    </AuthGuard>
  );
}